import { Pipe, PipeTransform } from '@angular/core';
import { AsYouType } from 'libphonenumber-js';
import { AppType } from 'src/lib/fliko/enums/appName';
import { ParserHlp } from 'src/lib/fliko/helpers/parser.helper';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { UnitLocation } from 'src/lib/fliko/models/units/unit.data';
import { ToStringHelper } from '../helpers/to-string.helper';
import { LocalizationService } from '../services/localization.service';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
  public transform(value: string): any {
    return StrHlp.capitalize(value);
  }
}

@Pipe({ name: 'join' })
export class JoinPipe implements PipeTransform {
  public transform(value: any, connector?: string, placeholder = ''): any {
    return StrHlp.join(value, { connector, placeholder });
  }
}

@Pipe({ name: 'fullName' })
export class FullNamePipe implements PipeTransform {
  public transform(value: any, placeholder = ''): any {
    return ToString.fullName(value) || placeholder;
  }
}

@Pipe({ name: 'nameContact' })
export class ContactNamePipe implements PipeTransform {
  public transform(value: any, placeholder = ''): any {
    return ToString.fullNameContact(value) || placeholder;
  }
}

@Pipe({ name: 'getPhone' })
export class GetPhonePipe implements PipeTransform {
  private formatter = new AsYouType('PL'); // if +XX code absent will format as polish (00 000 00 00 or 000 000 000)

  public transform(value: any, placeholder = '', index = 0): any {
    const number = ToString.getPhone(value, index);
    const out = this.formatter.input(number ?? '');
    this.formatter.reset();
    return out || placeholder;
  }
}

@Pipe({ name: 'getEmail' })
export class GetEmailPipe implements PipeTransform {
  public transform(value: any, placeholder = '', index = 0): any {
    return ToString.getEmail(value, index) || placeholder;
  }
}

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  private formatter = new AsYouType('PL'); // if +XX code absent will format as polish (00 000 00 00 or 000 000 000)

  public transform(value: string | null | undefined, placeholder = ''): string {
    const out = this.formatter.input(value ?? '');
    this.formatter.reset();
    return out || placeholder;
  }
}

@Pipe({ name: 'iban' })
export class IbanPipe implements PipeTransform {
  public transform(value: string | null | undefined, placeholder = ''): string {
    return ParserHlp.parseIbanDisplay(value) || placeholder;
  }
}

@Pipe({ name: 'nip' })
export class NipPipe implements PipeTransform {
  public transform(value: string | null | undefined, placeholder = ''): string {
    return ParserHlp.parseNipDisplay(value) || placeholder;
  }
}

@Pipe({ name: 'regon' })
export class RegonPipe implements PipeTransform {
  public transform(value: string | null | undefined, placeholder = ''): string {
    return ParserHlp.parseRegonDisplay(value) || placeholder;
  }
}

@Pipe({ name: 'or' })
export class ToStringOrPipe implements PipeTransform {
  public transform(value: any, placeholder: string): any {
    return ToString.or(value, placeholder);
  }
}

@Pipe({ name: 'appName' })
export class AppNamePipe implements PipeTransform {
  constructor(private ls: LocalizationService) {}

  public transform(value: AppType): string {
    return ToStringHelper.appName(value, (key) => this.ls.translate(key));
  }
}

@Pipe({ name: 'shortNumber' })
export class ShortNumberPipe implements PipeTransform {
  public transform(value: UnitLocation | null | undefined): string {
    return ToString.shortNumber(value);
  }
}

@Pipe({ name: 'longNumber' })
export class LongNumberPipe implements PipeTransform {
  public transform(value: UnitLocation | null | undefined): string {
    return ToString.longNumber(value);
  }
}

@Pipe({ name: 'short' })
export class ShortenPipe implements PipeTransform {
  public transform(value: string | null | undefined, length: number, start?: number): string {
    return value ? StrHlp.shorten(value, length, start) : '';
  }
}
